<template>
  <div>
    <el-dialog
      :visible.sync="dialogShow"
      :width="`${width}px`"
      :close-on-click-modal="false"
      @close="closeDialog"
      append-to-body
      class="tipConfirmDialogContent dialogBoxFormat"
      destroy-on-close
    >
      <div slot="title">
        {{ title }}
      </div>
      <slot></slot>
      <div class="btnFormat new_warehouse" v-if="showFooter" slot="footer">
        <el-button
          plain
          :loading="btnLoading"
          style="min-width: 65px; height: 32px; font-size: 14px"
          @click="closeDialog"
          >取消</el-button
        >
        <el-button
          style="min-width: 65px; height: 32px; font-size: 14px"
          :loading="btnLoading"
          type="primary"
          @click="confirm"
          >{{ confirmLabel }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  components: {},
  props: {
    dialogShow: {
      default: false,
    },
    title: {
      default: "",
    },
    confirmLabel: {
      default: "确定",
    },
    width: {
      default: 800,
    },
    btnLoading: {
      default: false,
    },
    showFooter: {
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closeDialog(e) {
      this.$emit("updateDialogShow", false);
    },
    confirm() {
      this.$emit("confirm");
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
};
</script>

<style scoped lang="less">
.tipConfirmDialogContent {
  font-size: 20px;
  color: #333;
  .tipConfirm-dialog-body {
    min-height: 120px;
    box-sizing: border-box;
    padding-bottom: 20px;
    padding-left: 36px;
    color: #333;
    line-height: 28px;
    font-size: 20px;
  }
  .title {
    font-weight: 500;
  }
  /deep/ .el-dialog {
    .el-dialog__footer {
      border-top: solid 1px #ccc;
    }
  }
}

.dialogBoxFormat {
  /deep/ .el-dialog__body {
    padding: 5px 0 !important;
  }
  /deep/ .el-dialog__header {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    height: 48px;
    align-items: center;
    color: #333333;
    padding: 0 0 0 20px !important;
    background: #f0f0f0;
  }
  /deep/ .el-dialog__headerbtn {
    top: 10px;
    font-size: 26px;
    .el-icon-close:before {
      color: #333;
      font-weight: 700;
    }
  }

  /deep/ .el-dialog__footer {
    padding: 10px 24px;
    border-radius: 0px 0px 5px 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ConfirmDialog.vue